import MessageOutlinedIcon from '@mui/icons-material/MessageOutlined';
import { Typography } from '@mui/material';
import { Variant } from '@mui/material/styles/createTypography';
import { TypographyPropsVariantOverrides } from '@mui/material/Typography/Typography';
import { OverridableStringUnion } from '@mui/types';
import styled from 'styled-components';

import { COLOR } from '@/globalStyles';

type RequestCommentProps = {
    className?: string;
    comment?: string;
    textVariant?: OverridableStringUnion<'inherit' | Variant, TypographyPropsVariantOverrides>;
};

const RequestComment = ({ className, comment, textVariant = 'table_text' }: RequestCommentProps) => {
    return (
        <div className={className}>
            <MessageOutlinedIcon sx={{ color: COLOR.zambezi }} />
            <Typography variant={textVariant} color={COLOR.zambezi}>
                {comment || <>&mdash;</>}
            </Typography>
        </div>
    );
};

const Styled = styled(RequestComment)``;
export default Styled;
